import UaParser from 'ua-parser-js'
import { isInAppUA } from './uaConfig'

export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`
}

/** 判断是否是移动端 */
export const isMobile = () => {
  const flag = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}

/** 判断是否为对象 */
export const isNullObject = (val: object) => {
  const data = { ...val }
  if (Object.keys(data).length === 0) {
    return false
  }
  return true
}

export function isString(val: unknown): val is string {
  return is(val, 'String')
}

/** 判断是否Touch屏幕 */
const isTouchScreen = () => {
  return (
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch)
  )
}

/** 判断是否为ipad */
export const isIpad = () => {
  const platform = window.navigator.platform
  const uaInfo = window.navigator.userAgent
  const macos = platform === 'MacIntel'
  const screenWidth = screen.width
  const screenHeight = screen.height
  if (uaInfo.match(/(iPad).*OS\s([\d_]+)/)) {
    return true
  }
  if (macos && isTouchScreen() && (
    (screenWidth === 1024 && screenHeight === 1366) || // Pro 12.9
    (screenWidth === 834 && screenHeight === 1194) || // Pro 11
    (screenWidth === 834 && screenHeight === 1112) || // Pro 10.5
    (screenWidth === 768 && screenHeight === 1024) // other
  )) {
    return uaInfo.match(/(Version)\/([\d.]+)/)
  }
}

/** 判断字符串是否为Json字符串 */
export function isJsonString(val: unknown): val is string {
  if (isString(val)) {
    try {
      const obj = JSON.parse(val)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

const uaParser = new UaParser()
const ua = navigator.userAgent || ''
// 判断设备类型
export const isAndroid = uaParser.getResult().os.name === 'Android' || /Android/i.test(ua)
export const isiOS = () => {
  if (uaParser.getResult().os.name === 'iOS' || isIpad() || /iphone|ipad|ipod|iOS/i.test(ua)) {
    return true
  } else if ((window as any).webkit) {
    return true
  }
  return false
}
// 是否在APP内
export const isAPP = isInAppUA(uaParser.getResult().ua)

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
export const isExternal = (path: string) => /^(https?:|mailto:|tel:|blob:)/.test(path)
